import { css, type Theme } from '@emotion/react';

export const container = css`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const tilesContainer = (theme: Theme) => css`
  display: grid;
  gap: 20px;
  grid-template-columns: 1fr;

  @media (min-width: ${theme.breakpoints.tiny}) {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
`;

export const titleContainer = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
